import { Primary } from '@decorators/entity-primary.decorator';
import { Required } from '@decorators/entity-required.decorator';
import { KeepProperty } from '@decorators/entity-keepproperty.decorator';

import { Entity } from './entity.class';

import { Rapport } from './rapport.class';
import { v4 as uuidv4 } from 'uuid';

export class RapportInvestigation implements Entity {
	@Required
	@Primary
	id: string;

	rapport: Rapport;

	render: string;
	renderEditor: string;

	logementId: string;
	logementNom: string;

	@KeepProperty
	elements?: string[];

	constructor() {	
		if (!this.id) this.id = uuidv4();
	}
	
}